import { checkValidNamedObject } from './named-object.js';
import { toRequiredSystemDefinedObject } from './system-defined-object.js';
export function toDoseUnit(doseUnit) {
    checkValidNamedObject(doseUnit, 'DoseUnit', 'DoseUnit');
    return {
        ...toRequiredSystemDefinedObject(doseUnit),
        description: doseUnit.description,
    };
}
//# sourceMappingURL=dose-unit.js.map